import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportZoomPageRoutingModule } from './report-zoom-routing.module';

import { ReportZoomPage } from './report-zoom.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxDatatableModule,
    TranslateModule.forChild(),
    ReportZoomPageRoutingModule
  ],
  declarations: [ReportZoomPage]
})
export class ReportZoomPageModule {}
